export default __webpack_public_path__ + "static/media/insta.f00d50b4.svg";